import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
  Legend,
} from "recharts";
import { Box, Typography } from "@mui/material";

// Sample data based on the new table
const data = [
  { category: "Watch", count: 250 },
  { category: "Read", count: 100 },
  { category: "Listen", count: 200 },
  { category: "Devotion", count: 50 },
  { category: "Play", count: 20 },
];

const ContentCategoryBarChart = () => {
  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart
        data={data}
        margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="category" />
        <YAxis />
        <Tooltip formatter={(value) => [`${value}`, "Number Of Hours"]} />
        <Legend formatter={(value) => "Number Of Hours"} />
        <Bar dataKey="count" fill="#82ca9d" />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default ContentCategoryBarChart;
